import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { REFERER, SERVER_REQUEST } from '@core/const';
import { AppComponent } from './app.component';
import { AppModule } from './app.module';
import { SpartacusFeaturesBrowserModule } from './spartacus/spartacus-features.browser.module';

@NgModule({
  bootstrap: [AppComponent],
  imports: [AppModule, BrowserModule, SpartacusFeaturesBrowserModule],
  providers: [
    {
      // The server provides these in main.server
      provide: SERVER_REQUEST,
      useFactory: (): Record<string, any> => ({ headers: { cookie: document.cookie } }),
    },
    {
      provide: REFERER,
      useFactory: (): string => document.referrer,
    },
  ],
})
export class AppBrowserModule {}
